"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenError = void 0;
var TokenError;
(function (TokenError) {
    /** Indicates that the current users login is invalid */
    TokenError["User"] = "user";
    /** Indicates that the current domain is not whitelisted */
    TokenError["Domain"] = "domain";
    /** Indicates that the requested scopes are not available for the current domain */
    TokenError["Scopes"] = "scopes";
    /** Indicates that the token could not be fetched due to a network error */
    TokenError["Network"] = "network";
    /** Indicates that the current token has expired */
    TokenError["Expired"] = "expired";
    /** Indicates that no token has been found */
    TokenError["NotFound"] = "not_found";
    /** Indicates an invalid token */
    TokenError["Invalid"] = "invalid";
})(TokenError = exports.TokenError || (exports.TokenError = {}));
